import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faInstagram,
  faSkype,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-blue-800 text-white  p-4 lg:p-6">
      <div className="container mx-auto flex flex-wrap justify-between  space-y-8 lg:space-y-0">
        {/* First Section */}
        <div className="w-full lg:w-1/3">
          <p className="text-lg leading-relaxed mb-6">
            <a class="  relative    before:content-[''] before:absolute before:left-1/2 before:-bottom-1  before:h-[2px] before:w-0 before:bg-green-600  before:transition-all before:duration-300  hover:before:left-0 hover:before:w-full text-green-600 font-bold" href="https://ayanshtechnology.com/">Ayanshtech Solutions</a> delivers expert <a class="  relative    before:content-[''] before:absolute before:left-1/2 before:-bottom-1  before:h-[2px] before:w-0 before:bg-green-600  before:transition-all before:duration-300  hover:before:left-0 hover:before:w-full text-green-600 font-bold"href="https://ayanshtechnology.com/devops-services"> DevOps consulting</a> and secure <a class="  relative    before:content-[''] before:absolute before:left-1/2 before:-bottom-1  before:h-[2px] before:w-0 before:bg-green-600  before:transition-all before:duration-300  hover:before:left-0 hover:before:w-full text-green-600 font-bold" href="https://ayanshtechnology.com/voip-business-solutions">VoIP development in India</a>. Our <a class="  relative    before:content-[''] before:absolute before:left-1/2 before:-bottom-1  before:h-[2px] before:w-0 before:bg-green-600  before:transition-all before:duration-300  hover:before:left-0 hover:before:w-full text-green-600 font-bold" href="https://ayanshtechnology.com/devops-services">DevOps</a> & <a class="  relative    before:content-[''] before:absolute before:left-1/2 before:-bottom-1  before:h-[2px] before:w-0 before:bg-green-600  before:transition-all before:duration-300  hover:before:left-0 hover:before:w-full text-green-600 font-bold" href="https://ayanshtechnology.com/voip-business-solutions">VoIP</a> as a Service model uses AI, cloud integration, and <a class="  relative    before:content-[''] before:absolute before:left-1/2 before:-bottom-1  before:h-[2px] before:w-0 before:bg-green-600  before:transition-all before:duration-300  hover:before:left-0 hover:before:w-full text-green-600 font-bold" href="https://ayanshtechnology.com/devops-ci-cd">CI/CD automation</a> to streamline your software delivery and upgrade communication systems. We ensure reliable, scalable operations with 10+ years of experience.
          </p>

          <a href="https://wa.me/8802319226">
            <button className="bg-yellow-500 hover:bg-yellow-600 text-white py-3 px-8 rounded-lg shadow-lg transition-transform transform hover:scale-105">
              Let’s Talk
            </button>
          </a>

          <div className="mt-8">
            <h3 className="text-lg font-bold mb-4">Have Questions?</h3>
            <p className="mb-2">India: +91-8802319226</p>
            <p className="mb-2">USA: +1-917-283-4232</p>
            <p className="mb-2">
              Email Enquiries:{" "}
              <a
                href="mailto:info@ayanshtechnology.com"
                className="text-yellow-400 underline hover:text-yellow-500"
              >
                info@ayanshtechnology.com
              </a>
            </p>
          </div>
        </div>
        <div className="text-white">
          <h3 className="text-lg font-bold mb-4">Important Links</h3>
          <a href="/">
            <p className="mb-2">Home</p>
          </a>
          <a href="/our-partners">
            <p className="mb-2">Our Partners</p>
          </a>
        </div>

        {/* Google Maps Section */}
        <div className="w-full lg:w-1/3">
          <h3 className="text-lg font-bold mb-2">Our Location</h3>
          <p className="mb-4">
            {" "}
            E-155, E Block, Sector 63, Noida, Uttar Pradesh 201301.
          </p>
          <div className="w-full h-96 bg-gray-400 rounded-lg overflow-hidden shadow-lg mb-4">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3510.064603828696!2d77.37324777575554!3d28.61650838239717!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce56218d63d57%3A0x33e5c29b4de2329c!2sE-155%2C%20E%20Block%2C%20Sector%2063%2C%20Noida%2C%20Uttar%20Pradesh%20201301!5e0!3m2!1sen!2sin!4v1696522896107!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Google Maps"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="container mx-auto flex flex-wrap justify-between items-center px-6 py-6 border-t border-gray-600">
        <div className="w-full lg:w-2/3 text-left">
          <p>
            © 2020-{currentYear} @{" "}
            <a href="https://ayanshtechnology.com/"><span className="font-bold">Ayanshtech Solutions.</span></a> All Rights
            Reserved
          </p>
          <div className="mt-2">
            <a
              href="/privacy-policy"
              className="mr-4 text-yellow-400 hover:text-yellow-500"
            >
              Privacy Policy
            </a>
            <a href="/terms" className="text-yellow-400 hover:text-yellow-500">
              Terms of Use
            </a>
          </div>
        </div>

        <div className="w-full lg:w-1/3 flex justify-center lg:justify-end items-center space-x-6">
          <p className="mr-2">Follow us on:</p>
          <a
            href="https://wa.me/8802319226"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-300 text-2xl"
          >
            <FontAwesomeIcon icon={faWhatsapp} />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61579642918710"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-300 text-2xl"
          >
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a
            href="https://www.linkedin.com/company/ayanshtech-solutions"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-300 text-2xl"
          >
            <FontAwesomeIcon icon={faLinkedinIn} />
          </a>
          <a
            href="https://www.instagram.com/ayanshtechsolutions/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-300 text-2xl"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
